import { faSquare, faSquareCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useRef, useState } from 'react';
import { Button, Col, Container, ListGroup, Row } from "react-bootstrap";

/**
 * Dropdown that allows to select multiple items. Select choices are not applied until the Apply button is pressed.
 */
export const MultiSelectMenu = ({ setShow, option, selectedItems, updateFilterOptions, availableItems, additionalClassNames }: any) => {

    const wrapperRef: any = useRef(null);
    const [localSelectedItems, setLocalSelectedItems] = useState<any>([...selectedItems]);

    useEffect(() => {
        function handleClickOutside(event: any) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setShow(false);
            }
        }
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [wrapperRef]);

    function toggleItem(item: any) {
        if (!localSelectedItems.includes(item)) {
            // Add this item to the local list
            setLocalSelectedItems([
                ...localSelectedItems,
                item,
            ]);
        } else {
            // Remove this item from the local list
            setLocalSelectedItems([...localSelectedItems.filter((obj: any) => obj !== item)]);
        }
    }

    return (
        <div ref={wrapperRef} className={`filter-select-container ${additionalClassNames}`} style={{ minWidth: '220px'}}>
            <Container className="p-0">
                <Row className="">
                    <Col md={12}>
                        <ListGroup style={{ maxHeight: '300px', overflow: 'scroll'}}>
                            {
                                availableItems.map((availableItem: any) => {
                                    return (
                                        <ListGroup.Item key={availableItem} action onClick={() => toggleItem(availableItem)}>
                                            {localSelectedItems.includes(availableItem) ? (
                                                <FontAwesomeIcon icon={faSquareCheck} style={{ marginRight: '8px' }} />
                                            ) : (
                                                <FontAwesomeIcon icon={faSquare} style={{ marginRight: '8px' }} />
                                            )}{' '}
                                            {availableItem}
                                        </ListGroup.Item>
                                    )
                                })
                            }
                        </ListGroup>
                    </Col>
                </Row>
                <Row className="pt-2 pb-1" style={{ marginRight: '1px' }}>
                    <Col md={12}>
                        <div className="float-end">
                            <Button style={{marginRight: '4px'}} variant="accent" size="sm" onClick={() => setLocalSelectedItems(localSelectedItems.length === availableItems.length ? [] : [...availableItems])}>Select All</Button>
                            <Button variant="secondary" size="sm" onClick={() => { updateFilterOptions(option, [...localSelectedItems]); setShow(false) }}>Apply</Button>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};
